import React from 'react';

const Loading = () => {
  return (
    <div id="tm__loading" className="tm2">
      <div className="full-loading">
        <div className="loader-center">
          <i className="fas fa-circle-notch fa-spin fa-5x"></i>
        </div>
      </div>
    </div>
  );
};

export default Loading;
